/**
 * Utilidades para formatear precios en formato español
 */

// Formatea como precio con símbolo de euro
export function formatPrecioES(value: number): string {
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
  }).format(value)
}

// Solo el número con coma decimal y dos decimales
export function formatDecimalES(value: number): string {
  return new Intl.NumberFormat('es-ES', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)
}

// Formatea precio con símbolo € al final (formato personalizado)
export function formatPrecioESCustom(value: number): string {
  return `${formatDecimalES(value)}€`
}
